/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import EnergySmartScoreDashboard from 'views/EnergySmartScoreDashboard/EnergySmartScoreDashboard';
import AuthGuard from './components/AuthGuard';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import Home from './views/Home';
import PresentationView from './views/Presentation';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import MapDriveTests from './views/MapDriveTests/components/MapDriveTests';
import MapDriveTestsGeneric from './views/MapDriveTestsGeneric/components/MapDriveTestsGeneric';
import DatasetExport from './views/DatasetExport/DatasetExport.js';
import STTMAlgorithm from './views/STTMAlgorithm/STTMAlgorithm.js';
import STTMAlgorithmGeneric from './views/STTMAlgorithmGeneric/STTMAlgorithmGeneric.js';
import SRCAAlgorithm from './views/SRCAAlgorithm/SRCAAlgorithm.js';
import SRCAAlgorithmGeneric from './views/SRCAAlgorithmGeneric/SRCAAlgorithmGeneric.js';
import SPFMAlgorithm from './views/SPFMAlgorithm/SPFMAlgorithm.js';
import SPFMAlgorithmGeneric from './views/SPFMAlgorithmGeneric/SPFMAlgorithmGeneric.js';
import DualMap from './views/DualMap/components/DualMap.js';
import DualMapGeneric from './views/DualMapGeneric/components/DualMapGeneric.js';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			// projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Home(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/modules',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/modules/sitesLocation',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: MapDriveTests()
								}),
							},
							{
								path: '/modules/sitesLocationGeneric',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'Client', 'CelfinetOS'],
									children: MapDriveTestsGeneric()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/datasetStats',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/datasetStats/dataStatistics_Counters',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 1 } }, pageTitle: 'Data Statistics', module: 'Modules' })
								}),
							},
							{
								path: '/datasetStats/dataStatistics_KPI',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 3 } }, pageTitle: 'Data Statistics_KPI', module: 'Modules' })
								}),
							},
							{
								path: '/datasetStats/dataStatistics_PMEnergy',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 5 } }, pageTitle: 'Data Statistics - ENERGY Data Statistics_PM Energy Consumption', module: 'Modules' })
								}),
							},
							{
								path: '/datasetStats/dataStatistics_CM',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 4 } }, pageTitle: 'Data Statistics_CM', module: 'Modules' })
								}),
							},
							{
								path: '/datasetStats/CanopyPM_EnergyConsumptionDashboard',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 6 } }, pageTitle: 'Energy Consumption Dashboard', module: 'Modules' })
								}),
							},
							{
								path: '/datasetStatsGeneric/CanopyPM_EnergyConsumptionDashboard_GenericData',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'Client', 'CelfinetOS'],
									children: DashboardInspect({ match: { params: { id: 7 } }, pageTitle: 'Energy Consumption Dashboard', module: 'Modules' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/datasetStatsGeneric',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/datasetStatsGeneric/CanopyPM_EnergyConsumptionDashboard_GenericData',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'Client', 'CelfinetOS'],
									children: DashboardInspect({ match: { params: { id: 7 } }, pageTitle: 'Energy Consumption Dashboard', module: 'Modules' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},

	{
		path: '/algorithms',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/algorithms/STTM_Algorithm',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: STTMAlgorithm()
								}),
							},
							{
								path: '/algorithms/SRCA_Algorithm',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: SRCAAlgorithm()
								}),
							},
							{
								path: '/algorithms/SPFM_Algorithm',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: SPFMAlgorithm()
								}),
							},
							{
								path: '/algorithms/CapacityManagement',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DualMap()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},

						],
					}

				}
			)
		}),
	},
	{
		path: '/algorithmsGeneric',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/algorithmsGeneric/STTM_Algorithm_GenericData',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'Client', 'CelfinetOS'],
									children: STTMAlgorithmGeneric()
								}),
							},
							{
								path: '/algorithmsGeneric/SRCA_Algorithm_GenericData',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'Client'],
									children: SRCAAlgorithmGeneric()
								}),
							},
							{
								path: '/algorithmsGeneric/SPFM_Algorithm_GenericData',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'Client'],
									children: SPFMAlgorithmGeneric()
								}),
							},
							{
								path: '/algorithmsGeneric/CapacityManagement_GenericData',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'Client'],
									children: DualMapGeneric()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},

						],
					}

				}
			)
		}),
	},
	{
		path: '/datasetExport',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/datasetExport',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'Client', 'CelfinetOS'],
									children: DatasetExport()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/energyWatchdog',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							/* 	{
								path: '/energyWatchdog/dataIntegrity',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 21 } }, pageTitle: 'Energy Watchdog - Data Integrity', module: 'Modules' })
								}),
							}, */
							{
								path: '/energyWatchdog/Canopy',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: EnergySmartScoreDashboard({ match: { params: { id: 21 } }, pageTitle: 'Energy Watchdog - CANOPY Smart Score Dashboard', module: 'Modules', project: 'CANOPY' })
								}),
							},
							{
								path: '/energyWatchdog/EW',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: EnergySmartScoreDashboard({ match: { params: { id: 23 } }, pageTitle: 'Energy Watchdog - EW Smart Score Dashboard', module: 'Modules', project: 'EW' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/energyWatchdogGeneric',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [

							{
								path: '/energyWatchdogGeneric/Canopy',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 22 } }, pageTitle: 'Energy Watchdog - CANOPY Smart Score Dashboard (Generic)', module: 'Modules' })
								}),
							},
							{
								path: '/energyWatchdogGeneric/EW',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									children: DashboardInspect({ match: { params: { id: 24 } }, pageTitle: 'Energy Watchdog - EW Smart Score Dashboard (Generic)', module: 'Modules' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/dashboards',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/inspect/:id',
								exact: true,
								component: (props) => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							}
						],
					}

				}
			)
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	}
];

export default routes;
